import { Bitmap, Container, delayedCall, dispatcher, ingenuity, killDelayedCall, Label, SpineBase } from "@quest/base-core";

import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";
import { SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { Linear, Sinusoidal } from "@quest/pixi-bridge";
import { HoldAndRespinIntroView } from "./HoldAndRespinIntroView";


export class HoldAndReSpinIntroController {
  protected view: HoldAndRespinIntroView;
  private introSpine: SpineBase;
  private bonusIntroContainer: Container;
  private bonusImageContainer: Container;
  private frameRight: Bitmap;
  private transitionAnim: SpineBase;
  private continueTextOutro:Label;
  private outroPopupBG:any;
  constructor(view: HoldAndRespinIntroView) {
    this.view = view;
    this.initializeElements();
    this.subscribeEvents();
  }
  private initializeElements(): void {
    this.bonusImageContainer = this.view.getContainerByID("bonusImageContainer");
    this.bonusIntroContainer = this.view.getContainerByID("bonusIntroContainer");
    this.frameRight = this.view.getImageById("frameRight");
    this.introSpine = this.view.getSpineById("bonus_intro") as SpineBase;
    this.transitionAnim = this.view.getSpineById("Transition_effect");
    this.continueTextOutro = this.view.getLabelById("continueTextOutro") as Label;
    this.outroPopupBG = this.view.getShapeById("outroPopupBG");
    this.frameRight.scale.x = this.frameRight.json.scaleX;
    this.bonusImageContainer.x = this.view.json.intialX[0];
    this.outroPopupBG.x = -640;
    this.outroPopupBG.y = -340;
  }
  private subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_HOLD_AND_RESPIN_INTRO, this.showHoldAndRespinIntro, this);
    //Binding the handler function of continue button of bonus intro screen
  }

  private unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.SHOW_HOLD_AND_RESPIN_INTRO, this.showHoldAndRespinIntro, this);
    //Removing the handler function of continue button of bonus intro screen
  }

  /**
   * bonus presentaiton starts from here
   */
  private showHoldAndRespinIntro(): void {
    this.bonusIntroContainer.visible = true;
    this.playTransitionAnim();
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, gameConstants.HOLD_RESPIN_BG_SHOW);
    dispatcher.fireEvent(eventDispatchers.HIDE_BASEGAME_ON_FEATURE);
    dispatcher.fireEvent(eventDispatchers.HIDE_BASEGAME_REEL);
    delayedCall(
      "hideBonusSymbol",
      300,
      () => {
        killDelayedCall("hideBonusSymbol");
        dispatcher.fireEvent(eventDispatchers.REMOVE_BONUS_FROM_WINPRESENTATION);
      },
      this
    );
    //Below is the code to play intro spine and show continue button
  }

  /**
     * add stage click to outro container
     */
    private onStageClickOutro(): void {
      this.continueTextOutro.visible = true;
      this.outroPopupBG.interactive = true;
      this.outroPopupBG.inputEnabled = true;
      this.outroPopupBG &&
        this.outroPopupBG.events.onInputUp.add((e: any) => {
          dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.COMMON_CLICK_SOUND, vol: 1, loop: false });
          this.onContinuePressUP();
          this.offStageClickOutro();
        }, this);
    }

    /**
   * remove stage click sfter click from outro container
   */
  private offStageClickOutro(): void {
    this.continueTextOutro.visible = false;
    this.outroPopupBG.interactive = false;
    this.outroPopupBG.inputEnabled = false;
    this.outroPopupBG && this.outroPopupBG.events.onInputUp.dispose();
  }

  /**
   * play intro spine
   */
  private playIntroSpine(): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_INTRO_BG,{action:'in'});
    this.introSpine.setPause(false);
    this.playThemeIntro();
  }

  /**
   * function to play transition animation
   * freegame to basegame, basegame to freegame
   */
  private playTransitionAnim() {
    (ingenuity.soundManager as any).playSound(
      SoundConstantGame.TRANSITION_SCREEN_SOUND,
      1,
      false,
      SlotConstantsBehavior.SOUND_LIST_POSTLOAD
    );
    this.transitionAnim.visible = true;
    this.transitionAnim.playAnim("transition", false);
    this.transitionAnim.onComplete.addOnce(() => {
      this.playIntroSpine();
      this.transitionAnim.visible = false;
    });
  }

  private playThemeIntro(): void {
    let triggerType = (ingenuity.parserModel as GameParserModel).getHoldAndRespinType();
    this.frameRight.x = this.frameRight.json.initialX + this.view.json.imageWidth * (triggerType.length - 1);
    this.introSpine.playAnim("bonusgame_in",false);
    this.tweenImageContainer();
    this.introSpine.onComplete.addOnce(() => {
      this.onStageClickOutro();
       this.introSpine.playAnim("bonusgame_loop",true);
      dispatcher.fireEvent(eventDispatchers.SHOW_INTRO_BG,{action:'loop'});
    }, this);
  }

  // private getTweenPosition(): any {
  //   let triggerType = (ingenuity.parserModel as GameParserModel).getHoldAndRespinType();
  //   let data: any;
  //   if (triggerType.length === 3) {
  //     data = { startPos: -500, midPos: -220 };
  //   } else if (triggerType.length === 2) {
  //     data = { startPos: -430, midPos: -150 };
  //   } else {
  //     data = { startPos: -320, midPos: -40 };
  //   }
  //   return data;
  // }

/**
 * tween image container from left to right
 */
  private tweenImageContainer(): void {
    //let data = this.getTweenPosition();
    (ingenuity.soundManager as any).playSound(SoundConstantGame.BONUS_INTRO_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    this.bonusImageContainer.x = this.view.json.intialX[0];
    this.showImageWithDelay();
    const fadeInTween = ingenuity.currentGame.add
      .tween(this.bonusImageContainer)
      .to({ x: -58 }, 60, Sinusoidal.InOut, true, 0, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      fadeInTween.stop();
      ingenuity.currentGame.tweens.remove(fadeInTween);
      this.playLoopTween();
    }, this);
  }

  private playLoopTween():void{
  ingenuity.currentGame.add.tween(this.bonusImageContainer).to({ x: -400 }, 1100, Linear.None, true, 0, -1, true);
  }

  private playOutTween():void{
    let tween  = ingenuity.currentGame.add.tween(this.bonusImageContainer).to({ x: 400 }, 60, Linear.None, true, 0, 0, false);
    tween.onComplete.addOnce(() => {
    this.bonusImageContainer.visible = false;
  });
  }
  /**
   * This method is use to hide continue button + to show intro end spine and start the bonus feature
   */
  private onContinuePressUP(): void {
    //show bonus and start the spinning
    this.playOutTween();
    this.introSpine.playAnim("bonusgame_out",false);
    dispatcher.fireEvent(eventDispatchers.SHOW_INTRO_BG,{action:'out'});
    dispatcher.fireEvent(eventDispatchers.HIDE_INTRO_BG);
    dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
    dispatcher.fireEvent(eventDispatchers.UPDATE_SPIN_REMAINING_COUNT);
  }

  private showImageWithDelay(): void {
    delayedCall('showImageWithDelay', 5 , () => {
      this.bonusImageContainer.visible = true;
      this.showThemeImage();
    });
  }
  /**
   * show intro skull symbol image as per triggered theme
   */
  private showThemeImage(): void {
    let triggerType = (ingenuity.parserModel as GameParserModel).getHoldAndRespinType();
    triggerType.forEach((element:any, index:number) => {
      if (element == gameConstants.SKULL_BIG_PRIZE) {
        this.view.getImageById("bigPrize_Image").visible = true;
        this.view.getImageById("bigPrize_Image").x = this.view.json.intialX[1] + this.view.json.imageWidth * index;
      }
      if (element == gameConstants.SKULL_COLLECT_ALL) {
        this.view.getImageById("collectAll_Image").visible = true;
        this.view.getImageById("collectAll_Image").x = this.view.json.intialX[1] + this.view.json.imageWidth * index;
      }
      if (element == gameConstants.SKULL_MULTIPLIER) {
        this.view.getImageById("multiplier_Image").visible = true;
        this.view.getImageById("multiplier_Image").x = this.view.json.intialX[1] + this.view.json.imageWidth * index;
      }
    });
  }

}
